import React from "react";
import { motion } from "framer-motion";
import { Award, Users, Clock, Shield, Star, Palette, Wrench, Eye, BadgeCheck, MapPin } from "lucide-react";

const features = [
  { icon: Clock, title: "9+ Years Expertise", description: "Industry-leading experience" },
  { icon: Users, title: "5091+ Happy Homes", description: "Proven track record" },
  { icon: Award, title: "End-to-End Execution", description: "Concept to completion" },
  { icon: Palette, title: "Dedicated Designer", description: "Personalized attention" },
  { icon: BadgeCheck, title: "Branded Materials", description: "Premium quality assured" },
  { icon: Shield, title: "On-time Delivery", description: "45-90 working days" },
  { icon: Wrench, title: "Warranty & AMC", description: "Up to 10 years" },
  { icon: Eye, title: "3D Visualization", description: "See before you build" },
  { icon: Star, title: "Transparent Pricing", description: "No hidden costs" },
  { icon: MapPin, title: "Experience Centers", description: "Multiple locations" },
];

export const WhyUsSection = () => {
  return (
    <section className="section bg-[hsl(var(--brand-onyx))] text-white relative overflow-hidden">
      <div className="noise-overlay"></div>
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-[hsl(var(--brand-champagne))]/70 mb-4">
            Why Choose Us
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-[hsl(var(--brand-champagne))]">
            Why Homz Interio
          </h2>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto">
            We blend your desires with our passion to deliver exquisite interiors
            that turn your dreams into aesthetical living spaces.
          </p>
        </motion.div>

        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6"
          data-testid="why-us-grid"
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                data-testid={`why-item-${index + 1}`}
              >
                <div className="glass-card p-6 rounded-xl h-full flex flex-col items-center text-center hover:bg-white/10 transition-colors">
                  <div className="w-14 h-14 rounded-full bg-[hsl(var(--brand-gold))]/20 flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-[hsl(var(--brand-gold))]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif-alt text-base font-semibold mb-2 text-[hsl(var(--brand-champagne))]">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-white/60">{feature.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
